import { NETWORK_NAMES, type RecipientItem, useIntl } from '@capsicum/common';

export const useNCWConfirmTransferFeeCard = ({ recipient: { networkType } }: { recipient: RecipientItem }) => {
	const { $t } = useIntl();

	const networkTypeLabel = NETWORK_NAMES[networkType];

	return {
		intlTexts: {
			network: $t('ncWallet.send.confirmation.network'),
			networkFee: $t('ncWallet.send.confirmation.networkFee'),
			networkFeeTooltip: $t('ncWallet.send.enterAmount.feeTooltip')
		},
		networkType,
		networkTypeLabel
	};
};
